const detailPage = (slug, hash = '') => `/resource-center/details/index.html?slug=${slug}${hash}`;

export const insightDetailUrls = {
  1: detailPage('sg-pdpa-2026'),
  2: detailPage('kr-pipa-2026'),
  3: detailPage('apac-resilience-baseline-2026')
}

export const downloadMeta = {
  1: {
    fileUrl: '/resource-center/downloads/apac-data-protection-readiness-checklist.pdf',
    fileName: 'apac-data-protection-readiness-checklist.pdf'
  },
  2: {
    fileUrl: '/resource-center/downloads/multi-region-dr-runbook-template.pdf',
    fileName: 'multi-region-dr-runbook-template.pdf'
  },
  3: {
    fileUrl: '/resource-center/downloads/managed-service-transition-checklist.pdf',
    fileName: 'managed-service-transition-checklist.pdf'
  }
}

export const knowledgeDetailUrls = {
  1: detailPage('k8s-etcd-runbook'),
  2: detailPage('distributed-incident-triage'),
  3: detailPage('security-compliance-checklist')
}

export const operationTipUrls = [
  detailPage('k8s-etcd-runbook'),
  detailPage('k8s-etcd-runbook'),
  '/resource-center/downloads/multi-region-dr-runbook-template.pdf',
  detailPage('distributed-incident-triage')
]

export const troubleshootingTipUrls = [
  detailPage('distributed-incident-triage'),
  detailPage('distributed-incident-triage'),
  '/resource-center/downloads/multi-region-dr-runbook-template.pdf',
  detailPage('apac-resilience-baseline-2026')
]

export const featuredEventUrl = detailPage('events-2026', '#featured')

export const recentEventUrls = {
  1: detailPage('events-2026', '#pdpa-webinar'),
  2: detailPage('events-2026', '#k8s-workshop'),
  3: detailPage('events-2026', '#dr-roundtable'),
  4: detailPage('events-2026', '#service-transition-briefing')
}
